import { Button, Intent, Popover } from "@blueprintjs/core";
import { default as UUID } from "node-uuid";
import { NavLink } from "react-router-dom";
import { getRouteByComponent } from "src/libs/layouts";
import { __ } from "src/libs/utilities";
import { IPETest, PE_TEST_QUESTION_TYPE } from "../../data/interfaces";
import { ITestsStore, useTestsStore } from "../../data/store";
import useGenTest from "../../hooks/useGenTest";

const Breadcrumbs = () : JSX.Element => { 
    const genTests: IPETest[]   = useTestsStore((state: ITestsStore) => state.genTests) 
    const genTest:  IPETest     = useGenTest()
    const onAdd = () => {
        const _tests: IPETest[] = [
            ...genTests.map(gt => gt.id === genTest.id 
                ? 
                {
                    ...genTest,
                    questions: [
                        ...genTest.questions,
                        {
                            id: UUID.v4(),
                            title: `${__("Question")} ${genTest.questions.length}`,
                            post_content: "",
                            answers: []
                        }
                    ]
                } as IPETest
                :
                gt
            )
        ]
        useTestsStore.setState({
            genTests : _tests
        })
    }
    const onRemove = (i :number) => {
        const _test: IPETest = {
            ...genTest,
            questions: genTest.questions.filter((q, n) => i !== n)  
        }
        const _tests: IPETest[] = [ ...genTests.map(gt => gt.id === genTest.id ? _test : gt ) ]
        useTestsStore.setState({ genTest : _tests })
    }
    const onCreate = () => {
        console.log( genTest )
    }
    const genUrl = getRouteByComponent("TestGeneratorView")?.route || ""
    return <div className="pe-test-bc-container">
        <NavLink to="cover" className="pe-test-bs-btn w-100">
            <Button minimal alignText="left" >
                <div className="d-flex hover">
                    <i className="fas fa-ellipsis-h mr-1"></i> 
                    <span>
                        { genTest.title }
                    </span>
                </div> 
            </Button>
        </NavLink>
        {
            genTest.questions?.map( (q, i) => {
                return  <div className="d-flex" key={q.id}>
                    <NavLink to={`/${genUrl}/${genTest.id}/${q.id}`} className="pe-test-bs-btn-2 flex-grow-100" key={ i }>
                        <Button minimal alignText="left" fill className="w-100">
                            <div className="d-flex  flex-grow-100 w-100">
                                <i className={`${ q.type === PE_TEST_QUESTION_TYPE.RANGE ? "fas fa-exchange-alt" : "fas fa-question" }  mr-2`} /> 
                                <span className="mr-1">{i+1}.</span>
                                <div className="text-overflow bs-btn  flex-grow-100 w-100">
                                    {q.title}    
                                </div> 
                            </div>
                        </Button>
                    </NavLink>
                    <Popover
                        content={<div className="p-2">{__("Double")}</div>}
                        interactionKind="hover"
                        position="left"
                    >
                        <Button minimal alignText="left" onClick={onAdd} className="pe-test-btn ">
                            <i className="far fa-copy " />
                        </Button> 
                    </Popover>
                     
                    <Popover
                        content={<div className="p-2">{__("Delete")}</div>}
                        interactionKind="hover"
                        position="right"
                    >
                        <Button 
                            minimal 
                            alignText="left" 
                            onClick={() => onRemove(i)} 
                            className="pe-test-btn "
                        >
                            <i className="far fa-trash-alt " />
                        </Button>
                    </Popover> 
                </div>
            })
        }
        
       
        <Button minimal alignText="left" onClick={onAdd} className="pe-test-btn">
            <span className="small descr text-force-contrast hover ">
                <i className="fas fa-plus mr-2" />{__("add question")}
            </span>
        </Button>  
        
        <Button large fill intent={Intent.DANGER} className="mt-3" onClick={ onCreate } alignText="left" icon="small-tick">
            <span className="small">
                {__("Save test and remove from generator")}
            </span>
        </Button>
        
    </div>
} 

export default Breadcrumbs